const getLangId = () => 1;

export default getLangId;
